







import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as Common from '@/agiles/common';

@Component
export default class Modal extends Vue {
  public showAlert: boolean = false;
  public alertTitle: string = '';
  public alertMessage: string = '';
  public html: string ='';
  public okOnly: boolean = false;
  public okTitle: string = '';
  public cancelTitle: string = '';
  public exec: () => void = () => {}; //ダミー
  public cancel:()=> void = ()=>{};
  public links:Common.ModalLink[] = [];
  public return_focus: any = null;
  public onOk(){
     if (this.exec) this.exec();
      this.showAlert = false;
  }
  public onCancel(){
      this.cancel();      
      this.showAlert = false;
  }  
  public updated(){
      this.return_focus = document.activeElement;
  }
  public onShown(){
          
              var el = document.getElementById('builtinModal___BV_modal_footer_');
              // (el.childNodes[1] as HTMLButtonElement).autofocus = true;
              (el.childNodes[1] as HTMLElement).focus();

  }

  public onClick(link:string, isExternalLink:boolean){
      this.showAlert = false;
      if(isExternalLink == true) window.open(link);
      else this.$router.push(link);
  }

}
